/**
 * Trims a string to the specified maximum length, adding "..." if it was trimmed.
 * @param {string?} str String to trim
 * @param {number} maxLength Maximum length of the string which can be displayed after trimming
 * @returns {string} Trimmed string, or original string if no trimming was necessary.
 * If input string is null/undefined, returns empty string.
 */
export function trimString(str, maxLength) {
  if (!str) {
    return "";
  }

  if (str.length <= maxLength) {
    return str;
  }
  return str.substring(0, maxLength) + "...";
}
